import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { SampleDetailsRecordObject } from '../../../shared/services/submission-history-object';
import { Subscription } from "rxjs";

@Component({
    selector: 'sample-details-table',
    templateUrl: './sample-details-table.component.html',
    styleUrls: [ './sample-details-table.component.scss' ]
})
export class SampleDetailsTableComponent implements OnInit, OnDestroy {

    activeFileRecordList: SampleDetailsRecordObject[] = new Array<SampleDetailsRecordObject>();
    uuid: string;
    sampleId: string;

    private sampleDetailsTable: Subscription;

    constructor(private submissionHistoryService: SubmissionHistoryService, private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.route.params.subscribe(res => {
            this.uuid = res.id;
            this.sampleId = res.sampleId;
            this.updateTableData();
        });
        this.sampleDetailsTable = this.submissionHistoryService.currentSampleDetailsTable.subscribe(message => {
            this.activeFileRecordList = message
        });
    }

    ngOnDestroy() {
        this.sampleDetailsTable.unsubscribe();
        this.submissionHistoryService.clearSampleDetailsTable();
    }

    public updateTableData(): void {
        this.submissionHistoryService.getSampleDetailsTableContent(this.uuid, this.sampleId);
    }
}
